export const dayIsAvailable = (min: Date, max: Date, date: Date) => {
  const minDate = new Date(min);
  const maxDate = new Date(max);
  const checkedDate = new Date(date);
  return (
    +new Date(minDate.setHours(0, 0, 0, 0)) <=
      +new Date(checkedDate.setHours(0, 0, 0, 0)) &&
    +new Date(checkedDate) <= +new Date(maxDate)
  );
};

export const disableRightArrow = (min: Date, checkedDate: Date) =>
  min.getFullYear() < checkedDate.getFullYear() ||
  (min.getFullYear() === checkedDate.getFullYear() &&
    min.getMonth() <= checkedDate.getMonth());

export const disableLeftArrow = (max: Date, checkedDate: Date) =>
  max.getFullYear() > checkedDate.getFullYear() ||
  (max.getFullYear() === checkedDate.getFullYear() &&
    max.getMonth() >= checkedDate.getMonth());

export const equalDates = (first: Date, second: Date) =>
  first.getDate() === second.getDate() &&
  first.getMonth() === second.getMonth() &&
  first.getFullYear() === second.getFullYear();

export const getDaysInMonth = (month: number, year: number) => {
  const firstDayOfMonth = new Date(year, month, 1);
  const weekdayOfFirstDay = firstDayOfMonth.getDay();
  const days = [];

  for (let day = 0; day < 42; day++) {
    if (day === 0 && weekdayOfFirstDay === 0) {
      firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 6);
    } else if (day === 0) {
      firstDayOfMonth.setDate(
        firstDayOfMonth.getDate() + (day - weekdayOfFirstDay + 1),
      );
    } else {
      firstDayOfMonth.setDate(firstDayOfMonth.getDate() + 1);
    }

    days.push({
      date: new Date(firstDayOfMonth),
      dayOfWeek: (firstDayOfMonth.getDay() - 1 + 7) % 7,
    });
  }

  return days;
};

export const organizeDaysIntoWeeks = (
  days: {
    date: Date;
    dayOfWeek: number;
  }[],
) => {
  const weeks = [];
  let week = new Array(7).fill(null);

  days.forEach((day: { date: Date; dayOfWeek: number }) => {
    if (day.dayOfWeek === 0 && week.some((d) => d !== null)) {
      weeks.push(week);
      week = new Array(7).fill(null);
    }
    week[day.dayOfWeek] = day;
  });

  if (week.some((d) => d !== null)) {
    weeks.push(week);
  }

  return weeks;
};

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const weekdays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export const generateTimeOptions = (
  date: Date | null,
  minDateTime: Date,
  maxDateTime: Date,
) => {
  if (!date) return [];

  const minTime = new Date(minDateTime).getTime();
  const maxTime = new Date(maxDateTime).getTime();
  const selectedDateTime = new Date(date).setHours(0, 0, 0, 0);

  let start = new Date(selectedDateTime);
  if (selectedDateTime <= minTime) start = new Date(minTime);

  let end = new Date(selectedDateTime + 86400000);
  if (selectedDateTime >= maxTime) end = new Date(maxTime);

  const options = [];
  while (start.getTime() <= end.getTime()) {
    if (start.getTime() >= minTime && start.getTime() <= maxTime) {
      const test = new Date(
        start.setMinutes(Math.ceil(start.getMinutes() / 15) * 15),
      );
      options.push(test.toTimeString().slice(0, 5));
    }
    start.setMinutes(Math.ceil(start.getMinutes() / 15) * 15 + 15); // Increment by 30 minutes
  }

  return options;
};
